import { RightPaneMetrics } from "types";
import styles from "./style.module.scss";
import { motion } from "framer-motion";

type ToggleMetricsProps = {
  selectedMetric: RightPaneMetrics;
  onToggle: () => void;
};

const ToggleMetrics = ({ selectedMetric, onToggle }: ToggleMetricsProps) => {
  return (
    <motion.label
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.03 }}
      transition={{ duration: 0.5 }}
      className={styles.toggleMetrics}
    >
      <span className={styles.icon}>%</span>
      <input
        className={styles.toggleInput}
        type="checkbox"
        checked={selectedMetric === "COUNT"}
        onChange={onToggle}
      />
      <span className={styles.slider}></span>
      <span className={styles.icon}>#</span>
    </motion.label>
  );
};

export default ToggleMetrics;
